import React from "react";
import PictureListItem from "@/react/Webshop/Components/Retouch/PictureListItem";
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles((theme) => ({
    list: {
        margin: 0,
        padding: 0,
        listStyle: "none",
        "& > li": {
            marginBottom: theme.spacing(3),
        },
    },
}));
const PictureList = ({ pictures, product, picturesSubProducts, handleToggleSubProduct, }) => {
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: classes.list }, pictures.map((picture) => {
            var _a;
            return (React.createElement("li", { key: picture.uuid },
                React.createElement(PictureListItem, { pictureUuid: picture.uuid, product: product, pictureSubProducts: (_a = picturesSubProducts[picture.uuid]) !== null && _a !== void 0 ? _a : [], handleToggleSubProduct: handleToggleSubProduct(picture.uuid) })));
        }))));
};
export default PictureList;
